export default __webpack_public_path__ + "static/media/Info-blue.564df472.svg";